import { gray, green, lightBlue, purple } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { ellipsis } from '@synoptic/ui-kit/utility.css.js';
import { globalStyle, style } from '@vanilla-extract/css';

export const pillIcon = style({
  flexShrink: 0,
  width: 16,
  height: 16,
});

export const streamListItemIconContainer = style([
  {
    width: 40,
    height: 40,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9999,
    background: themeVars.container.secondary.background.idle,
    color: themeVars.container.foreground.primary,
  },
]);

// Matching streams wear the same purple flame they carry everywhere else.
export const streamListItemMatchingIcon = style({
  color: themeVars.container.foreground.brand,
});

export const streamListItem = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  padding: `${space.s8}px`,
  flexWrap: 'wrap',
});

export const labelContent = style({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const pillRemove = style({
  selectors: {
    '&:is(&)': {
      width: 16,
      height: 16,
    },
  },
});

export const badge = style({
  maxWidth: `min(300px, 100%)`,
});

export const showMoreButton = style({
  color: themeVars.link.idle,
  background: 'transparent',
  padding: 0,

  selectors: {
    '&:disabled': {
      background: 'transparent',
      color: themeVars.link.idle,
    },
    '&:hover': {
      background: 'transparent',
    },
  },
});

globalStyle(`.${showMoreButton} :where(svg)`, {
  transform: 'rotate(90deg)',
  stroke: themeVars.link.idle,
  fill: themeVars.link.idle,
});

export const followingPill = style({
  display: 'flex',
  gap: space.s4,
  alignItems: 'center',
  ...typography.bodySm,
  color: themeVars.container.foreground.tertiary,
});

export const streamDetailsPill = style({
  display: 'flex',
  gap: space.s4,
  alignItems: 'center',
  ...typography.labelSm,
  padding: `${space.s4}px ${space.s8}px`,
  borderRadius: borderRadius.r32,
});

export const freeStreamPill = style([
  streamDetailsPill,
  {
    color: green[800],
    background: green[50],
  },
]);

export const inPackagePill = style([
  streamDetailsPill,
  {
    color: purple[800],
    background: purple[50],
  },
]);

export const paidStreamPill = style([
  streamDetailsPill,
  {
    color: purple[800],
    background: purple[50],
  },
]);

export const publicStreamPill = style([
  streamDetailsPill,
  {
    color: lightBlue[800],
    background: lightBlue[50],
  },
]);

export const privateStreamPill = style([
  streamDetailsPill,
  {
    color: gray[600],
    background: gray[300],
  },
]);

export const streamDetailsContainer = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  marginLeft: 'auto',
  flexWrap: 'wrap',
});

export const paidStreamContainer = style({
  border: `1px solid ${purple[100]}`,
  borderRadius: borderRadius.r8,
});

export const inPackageDisabledContainer = style({
  opacity: 0.5,
});

export const streamListItemDetails = style({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: space.s2,
  overflow: 'hidden',
  flex: 1,
});

export const streamListItemName = style([typography['titleSm'], ellipsis]);
export const streamListItemDescription = style([
  typography['bodySm'],
  {
    color: themeVars.container.foreground.tertiary,
  },
  ellipsis,
]);
